import React, { PropsWithChildren } from 'react'
import { Box } from '@node-space/ui-components'

export interface SidePanelSectionProps extends PropsWithChildren {
  heading?: string
}

export const SidePanelSection = ({ heading, children }: SidePanelSectionProps) => {
  return (
    <Box flexCol gap={12}>
      {heading && <h4 className="text-heading-4 text-prominent">{heading}</h4>}
      {children}
    </Box>
  )
}
